/**
 * Created by i.lovenkov on 14.10.16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    FullDescriptionView: {
        displayName: 'FullDescriptionView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/CartProduct/FullDescription/default/FullDescriptionView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var FullDescriptionView = _wrapComponent('FullDescriptionView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(FullDescriptionView, _Component);

    function FullDescriptionView(props) {
        (0, _classCallCheck3.default)(this, FullDescriptionView);
        return (0, _possibleConstructorReturn3.default)(this, (FullDescriptionView.__proto__ || (0, _getPrototypeOf2.default)(FullDescriptionView)).call(this, props));
    }

    (0, _createClass3.default)(FullDescriptionView, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                product_detail = _props.product_detail,
                lang = _props.lang,
                weight = void 0,
                weight_unit_id = void 0,
                vendor = void 0,
                country_of_origin = void 0,
                characteristics = [];

            // todo получить отображаемые характеристики товара с АПИ. Прописывать их здесь - не прикольно (с) Илья

            if (product_detail.hasOwnProperty('weight')) {
                // если свойство есть
                if (product_detail.weight) {
                    // если оно объявленно
                    weight = product_detail.weight;
                } else {
                    // если оно не объявленно
                    weight = 0;
                }
            }

            if (product_detail.hasOwnProperty('weight_unit_id')) {
                // если свойство есть
                if (product_detail.weight_unit_id) {
                    // если оно объявленно
                    weight_unit_id = product_detail.weight_unit_id;
                } else {
                    // если оно не объявленно
                    weight_unit_id = lang['store.full_description.weight_unit_id'];
                }
            }

            // если в характеристиках присутствует вес, отобразим его в характеристиках
            if (product_detail.hasOwnProperty('weight') && product_detail.hasOwnProperty('weight_unit_id')) {
                characteristics.push(_react3.default.createElement(
                    'li',
                    { key: "weight" },
                    _react3.default.createElement(
                        'label',
                        null,
                        lang['store.common.weight']
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'value' },
                        weight,
                        ' ',
                        weight_unit_id
                    )
                ));
            }

            // если есть производитель
            if (product_detail.hasOwnProperty('vendor')) {
                if (product_detail.vendor) {
                    vendor = product_detail.vendor;
                } else {
                    vendor = lang['store.full_description.vendor'];
                }
                characteristics.push(_react3.default.createElement(
                    'li',
                    { key: "vendor" },
                    _react3.default.createElement(
                        'label',
                        null,
                        lang['store.full_description.vendor']
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'value' },
                        vendor
                    )
                ));
            }

            // если указана страна производства
            if (product_detail.hasOwnProperty('country_of_origin')) {

                if (product_detail.country_of_origin) {
                    country_of_origin = product_detail.country_of_origin;
                } else {
                    country_of_origin = lang['store.common.russia'];
                }

                characteristics.push(_react3.default.createElement(
                    'li',
                    { key: "country_of_origin" },
                    _react3.default.createElement(
                        'label',
                        null,
                        lang['store.full_description.country_of_origin']
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'value' },
                        country_of_origin
                    )
                ));
            }

            return _react3.default.createElement(
                'section',
                { id: 'single-product-tab' },
                _react3.default.createElement(
                    'div',
                    { className: 'containers' },
                    _react3.default.createElement(
                        'div',
                        { className: 'tab-holder' },
                        _react3.default.createElement(
                            'ul',
                            { className: 'nav nav-tabs simple' },
                            _react3.default.createElement(
                                'li',
                                { className: 'active' },
                                _react3.default.createElement(
                                    'a',
                                    { href: '#additional-info', 'data-toggle': 'tab' },
                                    lang['store.full_description.сharacteristics']
                                )
                            ),
                            _react3.default.createElement(
                                'li',
                                null,
                                _react3.default.createElement(
                                    'a',
                                    { href: '#reviews', 'data-toggle': 'tab' },
                                    lang['store.full_description.reviews'],
                                    ' (1)'
                                )
                            )
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'tab-content' },
                            _react3.default.createElement(
                                'div',
                                { className: 'tab-pane active', id: 'additional-info' },
                                _react3.default.createElement(
                                    'ul',
                                    { className: 'tabled-data' },
                                    characteristics
                                )
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'tab-pane', id: 'reviews' },
                                _react3.default.createElement(_components2.ShowReview, null),
                                _react3.default.createElement(_components2.AddReview, null)
                            )
                        )
                    )
                )
            );
        }
    }]);
    return FullDescriptionView;
}(_react2.Component), _class.propTypes = {
    lang: _react2.PropTypes.object
}, _temp));

exports.default = FullDescriptionView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CartProduct/FullDescription/default/FullDescriptionView.jsx
// module id = 1628
// module chunks = 0